import Api from '../api'
export default ({
  state: {
    voucherNo: null,
    accountList: [],
    journalEntryList: [],
    voucherNoReceipt: null,
    voucherNoPayment: null,
    voucherNoDebitNo: null,
    voucherNoCreditNo: null,
    voucherNoCashDeposit: null,
    voucherNoCashWithdraw: null,
    voucherNoBankTransfer: null
  },
  mutations: {
    VOUCHER_NO(state, maxVoucherNo) {
      state.voucherNo = maxVoucherNo
    },
    VOUCHER_NO_RECEIPT(state, maxVoucherNoReceipt) {
      state.voucherNoReceipt = maxVoucherNoReceipt
    },
    VOUCHER_NO_PAYMENT(state, maxVoucherNoPayment) {
      state.voucherNoPayment = maxVoucherNoPayment
    },
    VOUCHER_NO_DEBIT_NOTE(state, maxVoucherNoDebitNote) {
      state.voucherNoDebitNo = maxVoucherNoDebitNote
    },
    VOUCHER_NO_CREDIT_NOTE(state, maxVoucherNoCreditNote) {
      state.voucherNoCreditNo = maxVoucherNoCreditNote
    },
    VOUCHER_NO_CASH_DEPOSIT(state, maxVoucherNoCashDeposit) {
      state.voucherNoCashDeposit = maxVoucherNoCashDeposit
    },
    VOUCHER_NO_CASH_WITHDRAW(state, maxVoucherNoCashWithdraw) {
      state.voucherNoCashWithdraw = maxVoucherNoCashWithdraw
    },
    VOUCHER_NO_BANK_TRANSFER(state, maxVoucherNoBankTransfer) {
      state.voucherNoBankTransfer = maxVoucherNoBankTransfer
    },
    ACCOUNT_MASTER_LIST(state, accountMasterList) {
      state.accountList = accountMasterList
    },
    JOURNAL_ENTRY(state, journalVoucher) {
      let journalEntry = state.journalEntryList.concat(journalVoucher)
      state.journalEntryList = journalEntry
    },
    RECEIPT_ENTRY(state, receiptVoucher) {
      let receiptEntry = state.journalEntryList.concat(receiptVoucher)
      state.journalEntryList = receiptEntry
    },
    PAYEMENT_ENYRY(state, paymentVoucher) {
      let paymentEntry = state.journalEntryList.concat(paymentVoucher)
      state.journalEntryList = paymentEntry
    }
  },
  actions: {
    async maxVoucherNo ({commit}) {
      let response = await Api.request('get', '/transactionMaster/journalEntryLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('VOUCHER_NO', responseValue)
      return response
    },
    async maxVoucherNoReceipt ({commit}) {
      let response = await Api.request('get', '/transactionMaster/receiptEntryLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('VOUCHER_NO_RECEIPT', responseValue)
      return response
    },
    async maxVoucherNoPayment ({commit}) {
      let response = await Api.request('get', '/transactionMaster/paymentEntryLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('VOUCHER_NO_PAYMENT', responseValue)
      return response
    },
    async maxVoucherNoDebitNote ({commit}) {
      let response = await Api.request('get', '/transactionMaster/debitNoteEntryLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('VOUCHER_NO_DEBIT_NOTE', responseValue)
      return response
    },
    async maxVoucherNoCreditNote ({commit}) {
      let response = await Api.request('get', '/transactionMaster/creditNoteEntryLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('VOUCHER_NO_CREDIT_NOTE', responseValue)
      return response
    },
    async maxVoucherNoCashDeposit ({commit}) {
      let response = await Api.request('get', '/transactionMaster/cashDepositEntryLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('VOUCHER_NO_CASH_DEPOSIT', responseValue)
      return response
    },
    async maxVoucherNoCashWithdraw ({commit}) {
      let response = await Api.request('get', '/transactionMaster/cashWithdrawLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('VOUCHER_NO_CASH_WITHDRAW', responseValue)
      return response
    },
    async maxVoucherNoBankTransfer ({commit}) {
      let response = await Api.request('get', '/transactionMaster/bankTransferLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('VOUCHER_NO_BANK_TRANSFER', responseValue)
      return response
    },
    async accountMasterList({commit}) {
      let resp = await Api.request('get', '/accountMaster/allAccountMasterListForTransaction/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = resp.data.data
      commit('ACCOUNT_MASTER_LIST', responseValue)
      return resp
    },
    async saveJournalEntry({commit}, journalObject) {
      let resp = await Api.request('post', '/transactionMaster/saveJournalEntry/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId, journalObject, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      let responseValue = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('JOURNAL_ENTRY', responseValue)
      }
      return resp
    },
    async saveReceiptEntry({commit}, receiptObject) {
      let resp = await Api.request('post', '/transactionMaster/saveReceiptEntry/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId, receiptObject)
      let responseValue = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('RECEIPT_ENTRY', responseValue)
      }
      return resp
    },
    async savePaymentEntry({commit}, paymentEntry) {
      let resp = await Api.request('post', '/transactionMaster/savePaymentEntry/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId, paymentEntry, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })

      let responseValue = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('PAYEMENT_ENYRY', responseValue)
      }
      return resp
    },
    async saveDebitNoteEntry({commit}, paymentEntry) {
      let resp = await Api.request('post', '/transactionMaster/saveDebitNoteEntry/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId, paymentEntry)
      let responseValue = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('DEBIT_NOTE_ENYRY', responseValue)
      }
      return resp
    },
    async saveCreditNoteEntry({commit}, paymentEntry) {
      let resp = await Api.request('post', '/transactionMaster/saveCreditNoteEntry/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId, paymentEntry)
      let responseValue = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('CREDIT_NOTE_ENYRY', responseValue)
      }
      return resp
    },
    async saveCashDeposit({commit}, cashDeposit) {
      let resp = await Api.request('post', '/transactionMaster/saveCashDeposit/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId, cashDeposit)
      let responseValue = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('JOURNAL_ENTRY', responseValue)
      }
      return resp
    },
    async saveCashWithdraw({commit}, cashWithdraw) {
      let resp = await Api.request('post', '/transactionMaster/saveCashWithdraw/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId, cashWithdraw)
      let responseValue = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('JOURNAL_ENTRY', responseValue)
      }
      return resp
    },
    async saveBankTransfer({commit}, cashWithdraw) {
      let resp = await Api.request('post', '/transactionMaster/saveBankTransfer/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId, cashWithdraw)
      let responseValue = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('JOURNAL_ENTRY', responseValue)
      }
      return resp
    },
    async addPostChequeDate({commit}, data) {
      let response = await Api.request('post', '/transactionMaster/postDatedCheckClearing/' + this.getters.organisationId + '/' + this.getters.userId + '/' + this.getters.fyId, data)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async purchaseListBillForDeduction({commit}, accountMasterId) {
      let response = await Api.request('get', '/inventoryInReport/getPurchaseListForBillDeduction/' + this.getters.organisationId + '/' + this.getters.fyId + '/' + accountMasterId)
      return response
    },
    async salesListBillForDeduction({commit}, accountMasterId) {
      let response = await Api.request('get', '/inventoryOutReport/getSalesListForBillDeduction/' + this.getters.organisationId + '/' + this.getters.fyId + '/' + accountMasterId)
      return response
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/accounting.js